'use client';

import Image from 'next/image';
import Link from 'next/link';

interface ServiceCardProps {
  id: string;
  icon: string;
  title: string;
  summary: string;
  offerings: string[];
  technologies: string[];
  outcome: string;
  index: number;
}

export function ServiceCard({
  icon,
  title,
  summary,
  offerings,
  technologies,
  outcome,
  index,
}: ServiceCardProps) {
  return (
    <article className="service-card flow" style={{ animationDelay: `${index * 0.1}s` }}>
      <div className="icon-wrapper">
        <Image src={icon} alt="" width={68} height={68} aria-hidden="true" />
      </div>
      <h2 className="card-title">{title}</h2>
      <p className="card-summary">{summary}</p>
      
      <div className="details-section">
        <h3>What&apos;s Included</h3>
        <ul className="offerings-list">
          {offerings.map((offering, i) => (
            <li key={i}>{offering}</li>
          ))}
        </ul>
      </div>

      <div className="technologies-section">
        <h3>Technologies</h3>
        <div className="tech-tags">
          {technologies.map((tech, i) => (
            <span key={i} className="tech-tag">
              {tech}
            </span>
          ))}
        </div>
      </div>

      <div className="outcome">
        <strong>Outcome:</strong> {outcome}
      </div>

      <Link href="/contact" className="cta" aria-label={`Get started with ${title}`}>
        Get Started
      </Link>
    </article>
  );
}
